import { validateZonePayload } from "../validator/validateZonePayload";
import { createZoneRequest } from "../../data/zoneApi";

export async function createZoneUseCase(payload) {
  const error = validateZonePayload(payload);

  if (error) {
    console.log(error);
    throw new Error(error);
  }
  console.log(payload);
  return await createZoneRequest(payload);
}
